<template>
  <vs-popup class="confirm-work-order-pop-up"
            :title="data.formulation_code + '- UNALLOCATED FG STOCK'"
            @close="open = false"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card no-shadow id="confirm-work-order-pop-up">
      <vx-card no-shadow class="pt-1">
        <div slot="no-body" class="mt-4">
          <vs-table
            :onlyClickCheckbox="true"
            v-model="selected"
            multiple
            id="sundry-item-list-table"
            :max-items="(meta.per_page) ? meta.per_page : 10"
            :data="items"
            sort
            :sst="true"
            class="table-dark-inverted table-auto vs-con-loading__container">

            <template slot="thead">
              <vs-th width="15%"  class="text-xs" sort-key="sundry_item_code">BATCH CODE</vs-th>
              <vs-th width="15%" class="text-xs">BATCH QTY (KG)</vs-th>
              <vs-th width="15%" class="text-xs">COMPLETED/AVAILABLE QTY (KG)</vs-th>
              <vs-th width="15%" class="text-xs">PRODUCT ORDER CODE</vs-th>
              <vs-th width="15%" class="text-xs">STATUS</vs-th>
              <vs-th width="10%" class="text-xs">QUANTITY (KG)</vs-th>
            </template>

            <template slot-scope="{data}">
              <vs-tr :data="tr" class="text-sm" style="cursor: pointer"  :key="indextr" v-for="(tr, indextr) in data">

                <vs-td class="text-primary font-semibold" :data="data[indextr].work_order">
                  {{ data[indextr].work_order}}
                </vs-td>

                <vs-td :data="data[indextr].total_quantity">
                  {{ data[indextr].total_quantity}}
                </vs-td>


                <vs-td :data="data[indextr].completed_quantity">
                  {{ data[indextr].completed_quantity}}
                </vs-td>

                <vs-td :data="data[indextr].product_order_code">
                  {{ data[indextr].product_order_code}}
                </vs-td>

                <vs-td :data="data[indextr].status">
                  <vs-chip transparent :color="'dark'" style="border-radius: 0" class="w-32">
                    {{ data[indextr].status}}
                  </vs-chip>
                </vs-td>


                <vs-td >
                  <div class="vx-row">
                    <vs-input v-if="data[indextr].status === 'In_Stock'" v-model="data[indextr].quantity" class="w-full required" />
                  </div>
                </vs-td>

              </vs-tr>
            </template>


          </vs-table>

          <div class="flex flex-wrap items-center justify-end mt-8" >
            <vs-button @click="onClickAdd()" id="save_change_button" button="submit" class="ml-auto mt-2">Confirm</vs-button>
          </div>

<!--          <vs-pagination-->
<!--            v-if="items.length > 0 "-->
<!--            v-on:changeMaxItems="changePage"-->
<!--            :size-array="meta.total ? meta.total : 20"-->
<!--            :max-items="perPage"-->
<!--            description-body="Rows per page"-->
<!--            description-connector="of"-->
<!--            description-title="Records"-->
<!--            description-->
<!--            :description-items="descriptionItems"-->
<!--            :total="(meta.last_page)? meta.last_page : 0"-->
<!--            v-model="page"  class="p-5">-->
<!--          </vs-pagination>-->


        </div>
      </vx-card>

    </vx-card>
  </vs-popup>
</template>

<script>
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  const ManufacturingRepository = RepositoryFactory.get('manufacturing')
  import flatPickr from 'vue-flatpickr-component'
  import 'flatpickr/dist/flatpickr.css'
  import vSelect from 'vue-select'
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  import {defaultPagination, perPageList} from "../../../../constants/config";

  function initialState() {
    return {
      open: false,
      id: '',
      data: null,
      items: [],
      filters: {},
      page : 1,
      total: 0,
      meta : {},
      sort : '',
      perPage: defaultPagination,
      descriptionItems: perPageList,
      selected: []
    }
  }

export default {
  name: 'ConfirmWorkOrderPopUp',
  data () {
    return initialState()
  },
  methods:{
    async openPopup (id) {
      try {
        await Object.assign(this.$data, initialState())
        this.id = id
        this.open = true
        // await this.fetchFormulationStockInventory()
      } catch (error) {

      }
    },
    async onClickAdd() {
      this.$emit('onAddReBlend', this.selected)
      this.open = false
    },

    async onClickConfirm (){
      const vue = this
      await this.$vs.loading({
        container: '#confirm-work-order-pop-up',
        scale: 0.45
      })
       try {
         const payload = {
           work_order_date: this.work_order_date,
           start_time: this.start_time,
           production_line_id: this.data.ProjectId
         }
         await ManufacturingRepository.updateWorkOrderDateTime(this.data.id, payload);
         this.showSuccessMessage('Work order update successfully')
         this.open = false;
         await vue.$emit('refresh')
         this.$vs.loading.close('#confirm-work-order-pop-up > .con-vs-loading')
       }catch (e) {
         this.$vs.loading.close('#confirm-work-order-pop-up > .con-vs-loading')
         this.convertAndNotifyError(e)
       }
    },
    async fetchFormulationStockInventory() {
      await this.$vs.loading()
      try {
        const {data} = await ManufacturingRepository.getFormulationStock(this.page, `filter[search]=${this.data.formulation_code}`, this.perPage)
        this.items =  data.data.map((n) => {
          n.quantity = 0
          return n
        })
        this.meta = data.meta
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close()
    },
    handleChangePage(page) {
      this.page=page;
      this.fetchFormulationStockInventory()
    },
    changePage(index) {
      this.perPage = this.descriptionItems[index]
    },
  },
  watch: {
    page(){
      this.fetchFormulationStockInventory()
    },
    perPage() {
      this.fetchFormulationStockInventory()
    },
  },
  components: {
    'v-select': vSelect,
    flatPickr
  },
  mixins: [SuccessMessage, ErrorMessages],
}
</script>

<style scoped>
  .confirm-work-order-pop-up >>> .vs-popup {
    /*min-height: 50% !important;*/
    min-width: 60% !important;
  }

</style>
